import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Header from "./components/layout/Header";
import EnvBadge from "./components/layout/EnvBadge";
import Home from "./pages/Home";
// import About from "./pages/About";
import Bookings from "./pages/Bookings";
import Service from "./pages/Service";
import Products from "./pages/Products";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Account from "./pages/Account";
import CompleteProfile from "./pages/CompleteProfile";
import { AuthProvider, useAuth } from "./context/AuthContext";
// import Contact from "./pages/Contact";

// Google sign-ups have no phone number yet. Send them to finish their profile
// before they go anywhere else, so the shop can always reach them.
function ProfileGate() {
  const { needsProfile } = useAuth();
  const location = useLocation();
  const exempt = ["/complete-profile", "/reset-password"];

  if (needsProfile && !exempt.includes(location.pathname)) {
    return (
      <Navigate
        to="/complete-profile"
        replace
        state={{ from: location.pathname === "/login" ? undefined : location.pathname }}
      />
    );
  }
  return null;
}

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <ProfileGate />
        <EnvBadge />
        <div style={{ minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              {/* <Route path="/about" element={<About />} /> */}
              <Route path="/contact" element={<Bookings />} />
              <Route path="/service" element={<Service />} />
              <Route path="/balls" element={<Products type="balls" />} />
              <Route path="/shoes" element={<Products type="shoes" />} />
              {/* <Route path="/contact" element={<Contact />} /> */}
              <Route path="/login" element={<Login key="login" />} />
              <Route path="/signup" element={<Login key="signup" />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/account" element={<Account key="orders" tab="orders" />} />
              <Route
                path="/account/profile"
                element={<Account key="profile" tab="profile" />}
              />
              <Route path="/complete-profile" element={<CompleteProfile />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
